let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("21L66")).then(() => parcelRequire('hoJj6'));